var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 37.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35353d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,37.33A37.11,37.11,0,0,1,.39,20.06a2.69,2.69,0,0,1,0-2.79A37.14,37.14,0,0,1,32,0,37.14,37.14,0,0,1,63.61,17.27a2.69,2.69,0,0,1,0,2.79A37.11,37.11,0,0,1,32,37.33ZM5.85,18.67A31.9,31.9,0,0,0,32,32,31.9,31.9,0,0,0,58.15,18.67,31.88,31.88,0,0,0,32,5.33,31.88,31.88,0,0,0,5.85,18.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,26.67a8,8,0,1,1,8-8A8,8,0,0,1,32,26.67ZM32,16a2.67,2.67,0,1,0,2.67,2.67A2.68,2.68,0,0,0,32,16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/passwordEye.995b255f2c2463e9ce1c4f9bdf2db702.svg";
export { ForwardRef as ReactComponent };